import { useLocation, Navigate, Outlet } from "react-router-dom";
import UseAuth from "../../hooks/UseAuth";

const isAuthed = (auth) =>
  Boolean(auth && auth.accessToken && auth.accessToken !== "");

// const isFullyVerified = (auth) =>
//   Boolean(
//     auth &&
//     (auth?.phone_verified == "true" || auth?.phone_verified == true) &&
//     (auth?.ocr_verified == "true" || auth?.ocr_verified == true),
//   );
const RequireNotAuth = () => {
  const { auth } = UseAuth();
  const location = useLocation();

  const authed = isAuthed(auth);
  // const fullyVerified = isFullyVerified(auth);

  // Guest → allow
  if (!authed) return <Outlet />;

  // Disabled (authed but not fully verified) → allow
  // if (authed && !fullyVerified) return <Outlet />;

  // Fully verified → redirect to app
  return (
    <Navigate
      to="/tax-declaration/list-data"
      state={{ from: location }}
      replace
    />
  );
};

export default RequireNotAuth;
